const state = {
  hasUnreadNotification: false,
  pendingAssignmentAppointmentCount: 0,
  unreadCount: 0,
};

const mutations = {
  setHasUnreadNotification(state, val) {
    state.hasUnreadNotification = val;
  },
  setPendingAssignmentAppointmentCount(state, val) {
    state.pendingAssignmentAppointmentCount = val;
  },
  setUnreadCount(state, val) {
    state.unreadCount = val;
  },
};

const actions = {};

const getters = {
  hasUnreadNotification: state => state.hasUnreadNotification,
  pendingAssignmentAppointmentCount: state => state.pendingAssignmentAppointmentCount,
  unreadCount: state => state.unreadCount,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
